import "../../../../content/projects/FreightExchange/FreightExchange.css";
import * as React from 'react';
export default {
  React
};